export default function IdeogramLogo() {
  return <img src="/logos/ideogram-logo.png" alt="Ideogram" width="16" height="16" className="block" />
}
